import { isObject, isString, removeChar } from "coreutils-js";
import orgConfig from '../../../../config';

export const nomarlizePath = function (path) {
  let fix_path = path.replace(/\/{1,}/g, "/");
  fix_path = removeChar(fix_path, "/", "begin_end_all");
  return fix_path;
};

export function linkTo(basename, path, pushState = false) {
  if (pushState) {
    window.history.pushState(
      {},
      undefined,
      "/" + nomarlizePath(`${basename}/${path}`)
    );
  } else {
    window.location.href = "/" + nomarlizePath(`${basename}/${path}`);
  }
}

export function redirectTo(url) {
  window.location.href = url;
}

export function nomarlizeBasename(basename = "") {
  return basename.replace(/:tenant_id\//, "");
}

export function getStorageValue(keyName: string, defaultValue?: any) {
  try {
    const value = window.localStorage.getItem(keyName);
    if (value) {
      return JSON.parse(value);
    } else {
      window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
      return defaultValue;
    }
  } catch (err) {
    return defaultValue;
  }
}

export function setStorageValue(keyName: string, newValue: any) {
  try {
    window.localStorage.setItem(keyName, JSON.stringify(newValue));
  } catch (err) { }
}

export function getAuthenticationConfig(clientId) {
  if (isString(orgConfig.authenticationConfig[clientId])) {
    return orgConfig.authenticationConfig[orgConfig.authenticationConfig[clientId]];
  }

  return orgConfig.authenticationConfig[clientId];
}

export function convertDatetimeString(datetimeStr = '') {
  if (isString(datetimeStr)) {
    return datetimeStr.replace('T', ' ').replace('Z', ' ');
  }

  return datetimeStr;
}

export const isEqualObject = (object1, object2) => {
  const objKeys1 = Object.keys(object1);
  const objKeys2 = Object.keys(object2);

  if (objKeys1.length !== objKeys2.length) return false;

  for (var key of objKeys1) {
    const value1 = object1[key];
    const value2 = object2[key];

    const isObjects = isObject(value1) && isObject(value2);

    if ((isObjects && !isEqualObject(value1, value2)) ||
      (!isObjects && value1 !== value2)
    ) {
      return false;
    }
  }
  return true;
}

/**
 * So sánh 2 mảng có giống nhau không ?
 * @param a
 * @param b
 * @returns `Boolean`
 */
export const compareArrays = (a, b) => a.length === b.length && a.every((element, index) => element === b[index]);
